// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cookie-floating-btn {
  position: fixed;
  bottom: 24px;
  left: 24px;
  z-index: 9999;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 3px solid #004481;
  background-color: #fff;
  color: #01a05f;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}
.cookie-floating-btn svg {
  transition: transform 0.3s ease;
}
.cookie-floating-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 24px rgba(0, 68, 129, 0.3);
}
.cookie-floating-btn:hover svg {
  transform: rotate(20deg);
}
.cookie-floating-btn:active {
  transform: scale(0.95);
}
@media (max-width: 991px) {
  .cookie-floating-btn {
    width: 48px;
    height: 48px;
    bottom: 16px;
    left: 16px;
  }
  .cookie-floating-btn svg {
    width: 24px;
    height: 24px;
  }
}

.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.4s ease-out;
}
.cookie-banner__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 26px;
  background: linear-gradient(135deg, #004481 0%, #031448 100%);
  position: relative;
}
@media (max-width: 991px) {
  .cookie-banner__header {
    padding: 10px 16px;
  }
}
.cookie-banner__header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}
@media (max-width: 991px) {
  .cookie-banner__header-content {
    gap: 8px;
  }
}
.cookie-banner__icon {
  color: #fff;
  flex-shrink: 0;
}
.cookie-banner__title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}
@media (max-width: 991px) {
  .cookie-banner__title {
    font-size: 14px;
  }
}
.cookie-banner__close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #01a05f;
  border: none;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  color: #fff;
  transition: all 0.3s ease;
}
.cookie-banner__close-btn:hover {
  background: linear-gradient(180deg, #01a05f 0%, #00ca78 100%);
}
.cookie-banner__close-btn:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}
@media (max-width: 991px) {
  .cookie-banner__close-btn {
    padding: 8px;
  }
}
.cookie-banner__body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 40px;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(40px);
  gap: 48px;
}
@media (max-width: 1199px) {
  .cookie-banner__body {
    gap: 24px;
  }
}
@media (max-width: 991px) {
  .cookie-banner__body {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 12px 16px;
    gap: 16px;
  }
}
.cookie-banner__text {
  flex: 1 0 50%;
  font-size: 16px;
  color: #1a1a2e;
  line-height: 1.5;
}
@media (max-width: 991px) {
  .cookie-banner__text {
    font-size: 12px;
    line-height: 1.6;
  }
}
.cookie-banner__link {
  color: #004481;
  text-decoration: underline;
}
.cookie-banner__link:hover {
  color: #01a05f;
}
.cookie-banner__actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 0 1 50%;
}
@media (max-width: 991px) {
  .cookie-banner__actions {
    gap: 6px;
    width: 100%;
  }
}
.cookie-banner__btn {
  flex: 1 1 auto;
  padding: 12px 24px;
  min-height: 48px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  border: 2px solid #004481;
  font-family: inherit;
}
@media (max-width: 991px) {
  .cookie-banner__btn {
    font-size: 13px;
    padding: 8px 12px;
    min-height: 42px;
  }
}
.cookie-banner__btn--primary {
  background: linear-gradient(135deg, #004481 0%, #031448 100%);
  color: #fff;
}
.cookie-banner__btn--primary:hover {
  background: linear-gradient(135deg, #003366 0%, #020f38 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 68, 129, 0.3);
}
.cookie-banner__btn--outline {
  background-color: transparent;
  color: #004481;
}
.cookie-banner__btn--outline:hover {
  background-color: #004481;
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 68, 129, 0.2);
}

.cookie-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10001;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}
@media (min-width: 992px) {
  .cookie-modal-overlay {
    align-items: center;
  }
}

.cookie-modal {
  background-color: #fff;
  width: 100%;
  max-width: 720px;
  max-height: 90vh;
  border-radius: 12px 12px 0 0;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.4s ease-out;
  position: relative;
}
@media (min-width: 992px) {
  .cookie-modal {
    border-radius: 12px;
    max-height: 80vh;
  }
}
.cookie-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 26px;
  background: linear-gradient(135deg, #004481 0%, #031448 100%);
  border-radius: 12px 12px 0 0;
}
@media (max-width: 991px) {
  .cookie-modal__header {
    padding: 14px 16px;
  }
}
.cookie-modal__header-content {
  display: flex;
  align-items: center;
  gap: 12px;
}
@media (max-width: 991px) {
  .cookie-modal__header-content {
    gap: 8px;
  }
}
.cookie-modal__title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}
@media (max-width: 991px) {
  .cookie-modal__title {
    font-size: 16px;
  }
}
.cookie-modal__close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #01a05f;
  border: none;
  border-radius: 50%;
  padding: 10px;
  cursor: pointer;
  color: #fff;
  transition: all 0.3s ease;
}
.cookie-modal__close-btn:hover {
  background: linear-gradient(180deg, #01a05f 0%, #00ca78 100%);
}
.cookie-modal__close-btn:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}
.cookie-modal__body {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px 24px 100px;
}
@media (max-width: 991px) {
  .cookie-modal__body {
    padding: 12px 12px 90px;
  }
}
.cookie-modal__description {
  font-size: 16px;
  color: #1a1a2e;
  line-height: 1.7;
  margin-bottom: 24px;
}
.cookie-modal__description a {
  color: #004481;
  text-decoration: underline;
}
@media (max-width: 991px) {
  .cookie-modal__description {
    font-size: 12px;
    line-height: 1.6;
    margin-bottom: 12px;
  }
}
.cookie-modal__accordion {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
}
@media (max-width: 991px) {
  .cookie-modal__accordion {
    margin-bottom: 12px;
  }
}
.cookie-modal__accordion-item {
  border-radius: 12px;
  overflow: hidden;
  background-color: #f8f8fa;
  transition: background-color 0.3s ease;
}
.cookie-modal__accordion-item.is-expanded {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
@media (max-width: 991px) {
  .cookie-modal__accordion-item {
    border-radius: 4px;
  }
}
.cookie-modal__accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  width: 100%;
  border: none;
  background-color: #f8f8fa;
  cursor: pointer;
  gap: 16px;
  border-bottom: 1px solid #e8e8e8;
  font-family: inherit;
}
@media (min-width: 992px) {
  .cookie-modal__accordion-header {
    padding: 20px 16px;
  }
}
.cookie-modal__accordion-header:hover {
  background-color: #f0f0f5;
}
.cookie-modal__accordion-left {
  display: flex;
  align-items: center;
  gap: 16px;
}
.cookie-modal__accordion-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid #01a05f;
  border-radius: 50%;
  flex-shrink: 0;
  transition: all 0.3s ease;
}
.cookie-modal__accordion-icon-wrap.is-expanded {
  background-color: #01a05f;
}
.cookie-modal__accordion-icon-wrap.is-expanded svg {
  color: #fff;
}
.cookie-modal__accordion-icon-wrap svg {
  color: #01a05f;
  transition: color 0.3s ease;
}
.cookie-modal__accordion-name {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
  text-align: left;
  transition: color 0.3s ease;
}
.is-expanded .cookie-modal__accordion-name {
  color: #01a05f;
}
@media (max-width: 991px) {
  .cookie-modal__accordion-name {
    font-size: 14px;
  }
}
.cookie-modal__accordion-panel {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  background-color: #fff;
}
.cookie-modal__accordion-panel.is-expanded {
  max-height: 200px;
  overflow-y: auto;
}
.cookie-modal__accordion-text {
  padding: 12px 16px;
  font-size: 14px;
  line-height: 1.7;
  color: #555;
}
@media (min-width: 992px) {
  .cookie-modal__accordion-text {
    padding: 20px 30px;
    font-size: 16px;
  }
}
.cookie-modal__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #f0f0f5;
  padding: 16px 24px;
  border-radius: 0 0 12px 12px;
}
@media (max-width: 991px) {
  .cookie-modal__footer {
    padding: 8px 12px 16px;
  }
}
.cookie-modal__footer-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  max-width: 100%;
  margin: 0 auto;
}
@media (max-width: 991px) {
  .cookie-modal__footer-actions {
    gap: 6px;
  }
}
.cookie-modal__btn {
  flex: 1 1 auto;
  padding: 12px 24px;
  min-height: 48px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  border: 2px solid #004481;
  font-family: inherit;
}
@media (max-width: 991px) {
  .cookie-modal__btn {
    font-size: 13px;
    padding: 8px 12px;
    min-height: 42px;
  }
}
.cookie-modal__btn--primary {
  background: linear-gradient(135deg, #004481 0%, #031448 100%);
  color: #fff;
}
.cookie-modal__btn--primary:hover {
  background: linear-gradient(135deg, #003366 0%, #020f38 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 68, 129, 0.3);
}
.cookie-modal__btn--outline {
  background-color: transparent;
  color: #004481;
}
.cookie-modal__btn--outline:hover {
  background-color: #004481;
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 68, 129, 0.2);
}

.cookie-toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}
.cookie-toggle__input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}
.cookie-toggle__input:checked + .cookie-toggle__slider {
  background-color: #01a05f;
}
.cookie-toggle__input:checked + .cookie-toggle__slider::before {
  transform: translateX(20px);
}
.cookie-toggle__input:disabled + .cookie-toggle__slider {
  opacity: 0.6;
  cursor: not-allowed;
}
.cookie-toggle__input:focus-visible + .cookie-toggle__slider {
  outline: 2px solid #004481;
  outline-offset: 2px;
}
.cookie-toggle__slider {
  width: 48px;
  height: 28px;
  background-color: #ccc;
  border-radius: 28px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  position: relative;
}
.cookie-toggle__slider::before {
  content: "";
  position: absolute;
  width: 22px;
  height: 22px;
  background-color: #fff;
  border-radius: 50%;
  top: 3px;
  left: 3px;
  transition: transform 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/cookie/CookieBanner.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,0CAAA;EACA,yBAAA;AAAF;AAEE;EACE,+BAAA;AAAJ;AAGE;EACE,qBAAA;EACA,4CAAA;AADJ;AAGI;EACE,wBAAA;AADN;AAKE;EACE,sBAAA;AAHJ;AAME;EAnCF;IAoCI,WAAA;IACA,YAAA;IACA,YAAA;IACA,UAAA;EAHF;EAKE;IACE,WAAA;IACA,YAAA;EAHJ;AACF;;AAQA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,2CAAA;EACA,gCAAA;AALF;AAOE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,6DAAA;EACA,kBAAA;AALJ;AAOI;EARF;IASI,kBAAA;EAJJ;AACF;AAOE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AALJ;AAOI;EALF;IAMI,QAAA;EAJJ;AACF;AAOE;EACE,WAAA;EACA,cAAA;AALJ;AAQE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AANJ;AAQI;EALF;IAMI,eAAA;EALJ;AACF;AAQE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;AANJ;AAQI;EACE,6DAAA;AANN;AASI;EACE,uBAAA;EACA,mBAAA;AAPN;AAUI;EArBF;IAsBI,YAAA;EAPJ;AACF;AAUE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,2CAAA;EACA,2BAAA;EACA,SAAA;AARJ;AAUI;EATF;IAUI,SAAA;EAPJ;AACF;AASI;EAbF;IAcI,sBAAA;IACA,uBAAA;IACA,uBAAA;IACA,SAAA;EANJ;AACF;AASE;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAPJ;AASI;EANF;IAOI,eAAA;IACA,gBAAA;EANJ;AACF;AASE;EACE,cAAA;EACA,0BAAA;AAPJ;AASI;EACE,cAAA;AAPN;AAWE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;AATJ;AAWI;EANF;IAOI,QAAA;IACA,WAAA;EARJ;AACF;AAWE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;AATJ;AAWI;EAbF;IAcI,eAAA;IACA,iBAAA;IACA,gBAAA;EARJ;AACF;AAUI;EACE,6DAAA;EACA,WAAA;AARN;AAUM;EACE,6DAAA;EACA,2BAAA;EACA,4CAAA;AARR;AAYI;EACE,6BAAA;EACA,cAAA;AAVN;AAYM;EACE,yBAAA;EACA,WAAA;EACA,2BAAA;EACA,4CAAA;AAVR;;AAiBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;AAdF;AAgBE;EAbF;IAcI,mBAAA;EAbF;AACF;;AAgBA;EACE,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,gCAAA;EACA,kBAAA;AAbF;AAeE;EAXF;IAYI,mBAAA;IACA,gBAAA;EAZF;AACF;AAcE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,6DAAA;EACA,4BAAA;AAZJ;AAcI;EARF;IASI,kBAAA;EAXJ;AACF;AAcE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAZJ;AAcI;EALF;IAMI,QAAA;EAXJ;AACF;AAcE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAZJ;AAcI;EALF;IAMI,eAAA;EAXJ;AACF;AAcE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;AAZJ;AAcI;EACE,6DAAA;AAZN;AAeI;EACE,uBAAA;EACA,mBAAA;AAbN;AAiBE;EACE,SAAA;EACA,gBAAA;EACA,wBAAA;AAfJ;AAiBI;EALF;IAMI,uBAAA;EAdJ;AACF;AAiBE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,cAAA;EACA,0BAAA;AAfN;AAkBI;EAXF;IAYI,eAAA;IACA,gBAAA;IACA,mBAAA;EAfJ;AACF;AAmBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAjBJ;AAmBI;EANF;IAOI,mBAAA;EAhBJ;AACF;AAmBE;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sCAAA;AAjBJ;AAmBI;EACE,sBAAA;EACA,yCAAA;AAjBN;AAoBI;EAXF;IAYI,kBAAA;EAjBJ;AACF;AAoBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,gCAAA;EACA,oBAAA;AAlBJ;AAoBI;EAbF;IAcI,kBAAA;EAjBJ;AACF;AAmBI;EACE,yBAAA;AAjBN;AAqBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AApBJ;AAsBI;EACE,yBAAA;AApBN;AAsBM;EACE,WAAA;AApBR;AAwBI;EACE,cAAA;EACA,2BAAA;AAtBN;AA0BE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;AAxBJ;AA0BI;EACE,cAAA;AAxBN;AA2BI;EAXF;IAYI,eAAA;EAxBJ;AACF;AA2BE;EACE,aAAA;EACA,gBAAA;EACA,gCAAA;EACA,sBAAA;AAzBJ;AA2BI;EACE,iBAAA;EACA,gBAAA;AAzBN;AA6BE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA3BJ;AA6BI;EANF;IAOI,kBAAA;IACA,eAAA;EA1BJ;AACF;AA8BE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;EACA,4BAAA;AA5BJ;AA8BI;EATF;IAUI,sBAAA;EA3BJ;AACF;AA8BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AA5BJ;AA8BI;EAPF;IAQI,QAAA;EA3BJ;AACF;AA8BE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;AA5BJ;AA8BI;EAbF;IAcI,eAAA;IACA,iBAAA;IACA,gBAAA;EA3BJ;AACF;AA6BI;EACE,6DAAA;EACA,WAAA;AA3BN;AA6BM;EACE,6DAAA;EACA,2BAAA;EACA,4CAAA;AA3BR;AA+BI;EACE,6BAAA;EACA,cAAA;AA7BN;AA+BM;EACE,yBAAA;EACA,WAAA;EACA,2BAAA;EACA,4CAAA;AA7BR;;AAoCA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AAjCF;AAmCE;EACE,UAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AAjCJ;AAmCI;EACE,yBAAA;AAjCN;AAoCI;EACE,2BAAA;AAlCN;AAqCI;EACE,YAAA;EACA,mBAAA;AAnCN;AAsCI;EACE,0BAAA;EACA,mBAAA;AApCN;AAwCE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,sCAAA;EACA,kBAAA;AAtCJ;AAwCI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,wCAAA;AAtCN;;AA4CA;EACE;IACE,2BAAA;IACA,UAAA;EAzCF;EA2CA;IACE,wBAAA;IACA,UAAA;EAzCF;AACF;AA4CA;EACE;IACE,UAAA;EA1CF;EA4CA;IACE,UAAA;EA1CF;AACF","sourcesContent":["// Floating Cookie Button - Sol Alt\n.cookie-floating-btn {\n  position: fixed;\n  bottom: 24px;\n  left: 24px;\n  z-index: 9999;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  border: 3px solid #004481;\n  background-color: #fff;\n  color: #01a05f;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  transition: all 0.3s ease;\n\n  svg {\n    transition: transform 0.3s ease;\n  }\n\n  &:hover {\n    transform: scale(1.1);\n    box-shadow: 0 6px 24px rgba(0, 68, 129, 0.3);\n\n    svg {\n      transform: rotate(20deg);\n    }\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  @media (max-width: 991px) {\n    width: 48px;\n    height: 48px;\n    bottom: 16px;\n    left: 16px;\n\n    svg {\n      width: 24px;\n      height: 24px;\n    }\n  }\n}\n\n// Cookie Banner Styles\n.cookie-banner {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10000;\n  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);\n  animation: slideUp 0.4s ease-out;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 26px;\n    background: linear-gradient(135deg, #004481 0%, #031448 100%);\n    position: relative;\n\n    @media (max-width: 991px) {\n      padding: 10px 16px;\n    }\n  }\n\n  &__header-content {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    @media (max-width: 991px) {\n      gap: 8px;\n    }\n  }\n\n  &__icon {\n    color: #fff;\n    flex-shrink: 0;\n  }\n\n  &__title {\n    font-size: 20px;\n    font-weight: 700;\n    color: #fff;\n\n    @media (max-width: 991px) {\n      font-size: 14px;\n    }\n  }\n\n  &__close-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #01a05f;\n    border: none;\n    border-radius: 50%;\n    padding: 10px;\n    cursor: pointer;\n    color: #fff;\n    transition: all 0.3s ease;\n\n    &:hover {\n      background: linear-gradient(180deg, #01a05f 0%, #00ca78 100%);\n    }\n\n    &:focus-visible {\n      outline: 2px solid #fff;\n      outline-offset: 2px;\n    }\n\n    @media (max-width: 991px) {\n      padding: 8px;\n    }\n  }\n\n  &__body {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 40px;\n    background-color: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(40px);\n    gap: 48px;\n\n    @media (max-width: 1199px) {\n      gap: 24px;\n    }\n\n    @media (max-width: 991px) {\n      flex-direction: column;\n      align-items: flex-start;\n      padding: 12px 12px 16px;\n      gap: 16px;\n    }\n  }\n\n  &__text {\n    flex: 1 0 50%;\n    font-size: 16px;\n    color: #1a1a2e;\n    line-height: 1.5;\n\n    @media (max-width: 991px) {\n      font-size: 12px;\n      line-height: 1.6;\n    }\n  }\n\n  &__link {\n    color: #004481;\n    text-decoration: underline;\n\n    &:hover {\n      color: #01a05f;\n    }\n  }\n\n  &__actions {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    flex: 0 1 50%;\n\n    @media (max-width: 991px) {\n      gap: 6px;\n      width: 100%;\n    }\n  }\n\n  &__btn {\n    flex: 1 1 auto;\n    padding: 12px 24px;\n    min-height: 48px;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    white-space: nowrap;\n    border: 2px solid #004481;\n    font-family: inherit;\n\n    @media (max-width: 991px) {\n      font-size: 13px;\n      padding: 8px 12px;\n      min-height: 42px;\n    }\n\n    &--primary {\n      background: linear-gradient(135deg, #004481 0%, #031448 100%);\n      color: #fff;\n\n      &:hover {\n        background: linear-gradient(135deg, #003366 0%, #020f38 100%);\n        transform: translateY(-1px);\n        box-shadow: 0 4px 12px rgba(0, 68, 129, 0.3);\n      }\n    }\n\n    &--outline {\n      background-color: transparent;\n      color: #004481;\n\n      &:hover {\n        background-color: #004481;\n        color: #fff;\n        transform: translateY(-1px);\n        box-shadow: 0 4px 12px rgba(0, 68, 129, 0.2);\n      }\n    }\n  }\n}\n\n// Cookie Modal Overlay\n.cookie-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 10001;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  animation: fadeIn 0.3s ease;\n\n  @media (min-width: 992px) {\n    align-items: center;\n  }\n}\n\n.cookie-modal {\n  background-color: #fff;\n  width: 100%;\n  max-width: 720px;\n  max-height: 90vh;\n  border-radius: 12px 12px 0 0;\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.4s ease-out;\n  position: relative;\n\n  @media (min-width: 992px) {\n    border-radius: 12px;\n    max-height: 80vh;\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 18px 26px;\n    background: linear-gradient(135deg, #004481 0%, #031448 100%);\n    border-radius: 12px 12px 0 0;\n\n    @media (max-width: 991px) {\n      padding: 14px 16px;\n    }\n  }\n\n  &__header-content {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    @media (max-width: 991px) {\n      gap: 8px;\n    }\n  }\n\n  &__title {\n    font-size: 20px;\n    font-weight: 700;\n    color: #fff;\n\n    @media (max-width: 991px) {\n      font-size: 16px;\n    }\n  }\n\n  &__close-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #01a05f;\n    border: none;\n    border-radius: 50%;\n    padding: 10px;\n    cursor: pointer;\n    color: #fff;\n    transition: all 0.3s ease;\n\n    &:hover {\n      background: linear-gradient(180deg, #01a05f 0%, #00ca78 100%);\n    }\n\n    &:focus-visible {\n      outline: 2px solid #fff;\n      outline-offset: 2px;\n    }\n  }\n\n  &__body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 20px 24px 100px;\n\n    @media (max-width: 991px) {\n      padding: 12px 12px 90px;\n    }\n  }\n\n  &__description {\n    font-size: 16px;\n    color: #1a1a2e;\n    line-height: 1.7;\n    margin-bottom: 24px;\n\n    a {\n      color: #004481;\n      text-decoration: underline;\n    }\n\n    @media (max-width: 991px) {\n      font-size: 12px;\n      line-height: 1.6;\n      margin-bottom: 12px;\n    }\n  }\n\n  // Accordion\n  &__accordion {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 24px;\n\n    @media (max-width: 991px) {\n      margin-bottom: 12px;\n    }\n  }\n\n  &__accordion-item {\n    border-radius: 12px;\n    overflow: hidden;\n    background-color: #f8f8fa;\n    transition: background-color 0.3s ease;\n\n    &.is-expanded {\n      background-color: #fff;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    }\n\n    @media (max-width: 991px) {\n      border-radius: 4px;\n    }\n  }\n\n  &__accordion-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px;\n    width: 100%;\n    border: none;\n    background-color: #f8f8fa;\n    cursor: pointer;\n    gap: 16px;\n    border-bottom: 1px solid #e8e8e8;\n    font-family: inherit;\n\n    @media (min-width: 992px) {\n      padding: 20px 16px;\n    }\n\n    &:hover {\n      background-color: #f0f0f5;\n    }\n  }\n\n  &__accordion-left {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n\n  &__accordion-icon-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    border: 1px solid #01a05f;\n    border-radius: 50%;\n    flex-shrink: 0;\n    transition: all 0.3s ease;\n\n    &.is-expanded {\n      background-color: #01a05f;\n\n      svg {\n        color: #fff;\n      }\n    }\n\n    svg {\n      color: #01a05f;\n      transition: color 0.3s ease;\n    }\n  }\n\n  &__accordion-name {\n    font-size: 16px;\n    font-weight: 600;\n    color: #1a1a2e;\n    text-align: left;\n    transition: color 0.3s ease;\n\n    .is-expanded & {\n      color: #01a05f;\n    }\n\n    @media (max-width: 991px) {\n      font-size: 14px;\n    }\n  }\n\n  &__accordion-panel {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.3s ease;\n    background-color: #fff;\n\n    &.is-expanded {\n      max-height: 200px;\n      overflow-y: auto;\n    }\n  }\n\n  &__accordion-text {\n    padding: 12px 16px;\n    font-size: 14px;\n    line-height: 1.7;\n    color: #555;\n\n    @media (min-width: 992px) {\n      padding: 20px 30px;\n      font-size: 16px;\n    }\n  }\n\n  // Footer\n  &__footer {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: #f0f0f5;\n    padding: 16px 24px;\n    border-radius: 0 0 12px 12px;\n\n    @media (max-width: 991px) {\n      padding: 8px 12px 16px;\n    }\n  }\n\n  &__footer-actions {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    max-width: 100%;\n    margin: 0 auto;\n\n    @media (max-width: 991px) {\n      gap: 6px;\n    }\n  }\n\n  &__btn {\n    flex: 1 1 auto;\n    padding: 12px 24px;\n    min-height: 48px;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    white-space: nowrap;\n    border: 2px solid #004481;\n    font-family: inherit;\n\n    @media (max-width: 991px) {\n      font-size: 13px;\n      padding: 8px 12px;\n      min-height: 42px;\n    }\n\n    &--primary {\n      background: linear-gradient(135deg, #004481 0%, #031448 100%);\n      color: #fff;\n\n      &:hover {\n        background: linear-gradient(135deg, #003366 0%, #020f38 100%);\n        transform: translateY(-1px);\n        box-shadow: 0 4px 12px rgba(0, 68, 129, 0.3);\n      }\n    }\n\n    &--outline {\n      background-color: transparent;\n      color: #004481;\n\n      &:hover {\n        background-color: #004481;\n        color: #fff;\n        transform: translateY(-1px);\n        box-shadow: 0 4px 12px rgba(0, 68, 129, 0.2);\n      }\n    }\n  }\n}\n\n// Toggle Switch\n.cookie-toggle {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n\n  &__input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n    position: absolute;\n\n    &:checked + .cookie-toggle__slider {\n      background-color: #01a05f;\n    }\n\n    &:checked + .cookie-toggle__slider::before {\n      transform: translateX(20px);\n    }\n\n    &:disabled + .cookie-toggle__slider {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n\n    &:focus-visible + .cookie-toggle__slider {\n      outline: 2px solid #004481;\n      outline-offset: 2px;\n    }\n  }\n\n  &__slider {\n    width: 48px;\n    height: 28px;\n    background-color: #ccc;\n    border-radius: 28px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    position: relative;\n\n    &::before {\n      content: '';\n      position: absolute;\n      width: 22px;\n      height: 22px;\n      background-color: #fff;\n      border-radius: 50%;\n      top: 3px;\n      left: 3px;\n      transition: transform 0.3s ease;\n      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n    }\n  }\n}\n\n// Animations\n@keyframes slideUp {\n  from {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
